import Vue from 'vue'
import $ from 'jquery'
import {
    Toast,
    Indicator
} from 'mint-ui';
import router from '../router'
import params from "../components/freshAir/params/index.vue";

let BASE_URL = process.env.BASE_URL;


function post(url, data, success, error) {
    var _this = this;
    if (!data) {
        data = {}
    }
    var headers = {};
    var token = localStorage.getItem('token');
    if (token) {
        headers['Authorization'] = 'Bearer ' + token;
    }
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: BASE_URL + url,
        data: JSON.stringify(data),
        dataType: 'json',
        headers: headers,
        success: function (res) {
            Indicator.close();
            if (res.code !== 200) {
                Toast(res.msg);
            } else if (success) {
                success(res);
            }
        },
        error: function (res) {
            Indicator.close();
            if (res.code === 401) {
                router.push('/login');
            } else {
                if (error) {
                    error(res);
                } else {
                    // Toast("网络连接超时，请刷新重试");
                }
            }
        }
    });
}

function put(url, data, success, error) {
    var _this = this;
    if (!data) {
        data = {}
    }
    $.ajax({
        type: 'PUT',
        contentType: 'application/json',
        url: BASE_URL + url,
        data: JSON.stringify(data),
        dataType: 'json',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token') // 将YourTokenHere替换为你的实际Bearer Token
        },
        success: function (res) {
            Indicator.close();
            if (res.code !== 200) {
                Toast(res.msg);
            } else if (success) {
                success(res);
            } else {
                Toast("未知错误，请联系管理员")
            }
        },
        error: function (res) {
            Indicator.close();
            if (res.code === 401) {
                router.push('/login');
            } else {
                if (error) {
                    error(res);
                } else {
                    // Toast("网络连接超时，请刷新重试");
                }
            }
        }
    });
}

function get(url, success, error) {
    var _this = this;
    $.ajax({
        type: 'GET',
        url: BASE_URL + url,
        dataType: 'json',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token') // 将YourTokenHere替换为你的实际Bearer Token
        },
        success: function (res) {
            Indicator.close();
            if (res.code === 401) {
                router.push('/login');
                Toast("会话过期，请重新登陆")
            } else if (res.code !== 200) {
                Toast(res.msg);
            } else if (success) {
                success(res);
            } else {
                Toast("未知错误，请联系管理员")
            }
        },
        error: function (res) {
            Indicator.close();
            if (res.status === 401) {
                router.push('/login');
                Toast("会话过期，请重新登陆")
            } else {
                if (error) {
                    error(res);
                } else {
                    // Toast("网络连接超时，请刷新重试");
                }
            }
        }
    });
}

const URL = {
    sendSms: '/sms',
    register: '/custom/user/register',
    login: '/custom/user/login',
    logout: '/custom/user/logout',
    resetPassword: '/custom/user/password',
    eqList: '/iot/device/user/list',
    eqDel: '/api/equipment/delete',
    eqDetail: '/iot/device/user',
    faultList: '/iot/air_condition/alarm/untreated',
    timerTask: '/iot/device/schedules',
    addTimerTask: '/iot/device/schedules',
    updateTimerTask: '/iot/device/schedules',
    delTimerTask: '/iot/device/schedules/del',
    eqSave: '/api/equipment/save',
    eqBind: '/iot/device/user/add',
    eqText: '/iot/device/wait/match',//查询设备识别码
    eqMatch: '/iot/device/match', //开始匹配
    eqRoomList: '/custom/scene/room',
    eqRoomAdd: '/custom/scene/room/add',
    useSceneList: '/custom/scene/list/user',
    useSceneAdd: '/custom/scene/add',
    eqUnbind: '/iot/device/unbind/user',
    updateMobilePhone: '/custom/user/phonenumber',
    authUser: '/custom/user/self',
    editScene: '/custom/scene',
    delScene: '/custom/scene/delete',
    updateBind: '/iot/device/room',
    delRoom: '/custom/scene/room/delete',
    editRoom: '/custom/scene/room',
    editEqName: '/iot/device/name',

    // 主机
    startUp: '/iot/air_condition/control/power_on',
    shutDown: '/iot/air_condition/control/power_off',
    adjustHeatMode: '/iot/air_condition/control/hot_mode',
    adjustCoolMode: '/iot/air_condition/control/code_mode',
    adjustHeatTemperature: '/iot/air_condition/control/hot_mode/temp',
    adjustCoolTemperature: '/iot/air_condition/control/code_mode/temp',
    readWaterTemerature: '/api/mainEquipment/readWaterTemerature',

    // 风盘接口
    startUpFan: '/iot/fan_coil/control/power_on',
    shutDownFan: '/iot/fan_coil/control/power_off',
    adjustHeatModeFan: '/iot/fan_coil/control/hot_mode',
    adjustCoolModeFan: '/iot/fan_coil/control/cool_mode',
    adjustVentilationMode: '/iot/fan_coil/control/ventilate_mode',
    adjustUnderMode: '/iot/fan_coil/control/under_mode',
    adjustUnderHeatMode: '/iot/fan_coil/control/under_heat_mode',
    adjustHeatTemperatureFan: '/iot/fan_coil/control/hot_temp',
    adjustCoolTemperatureFan: '/iot/fan_coil/control/cool_temp',
    adjustWindSpeed: '/iot/fan_coil/control/speed',

    // 设备报修
    equipmentRepairAdd: '/custom/repair',
    equipmentRepairAddWx: '/custom/repair/wx',

    //  产品应用
    articleList: '/api/article/list',
    articleGet: '/api/article/get',

    /*新风设备*/
    freshStartUp: '/iot/air_ventilator/control/power_on',
    freshShutDown: '/iot/air_ventilator/control/power_off',
    freshAdjustHeatMode: '/iot/air_ventilator/control/hot_mode',
    freshAdjustCoolMode: '/iot/air_ventilator/control/code_mode',
    freshAdjustVentilationMode: '/iot/air_ventilator/control/ventilation_mode',
    freshAdjustHeatTemperature: '/iot/air_ventilator/control/heat/temp',
    freshAdjustCoolTemperature: '/iot/air_ventilator/control/code/temp',
    freshAdjustCoolHumidity: '/iot/air_ventilator/control/cool/humidity',
    freshAdjustHeatHumidity: '/iot/air_ventilator/control/heat/humidity',
    freshEquipmentDetail: '/api/xinFengEquipment/detail',
    wxAcc: '/wx/access',

    /*除湿机*/
    dehumStartUp: "/iot/denum/control/power_on",
    dehumStartDown: "/iot/denum/control/power_off",
    dehumidificationMode: "/iot/denum/control/mode",
    loopMode: "/iot/denum/control/loop",
    windSpeed: "/iot/denum/control/speed",
    sterilizationMode: "/iot/denum/control/sterilization",
    homeCoolingHumiditySetting: "/iot/denum/control/humidity",
};

const Api = {
        saveInfo() {
            sessionStorage.setItem('token', new Date().getTime())
        },
        delInfo() {
            sessionStorage.removeItem('token')
        },
        getInfo() {
            var flag = sessionStorage.getItem('token');
            return flag;
        },
        login(data, success, err) {
            post(URL.login, data, success, err)
        },
        logout(success, err) {
            get(URL.logout, success, err)
        },
        register(data, success, err) {
            post(URL.register, data, success, err)
        },
        sendSms(data, success, err) {
            post(URL.sendSms, data, success, err)
        },
        resetPassword(data, success, err) {
            post(URL.resetPassword, data, success, err)
        },
        eqList(str, success, err) {
            get(URL.eqList + '?' + str, success, err)
        },
        eqListAll(success, err) {
            get(URL.eqList, success, err)
        },
        eqDel(data, success, err) {
            post(URL.eqDel, data, success, err)
        },
        eqDetail(id, success, err) {
            get(URL.eqDetail + '/' + id, success, err)
        },
        faultList(str, success, err) {
            get(URL.faultList + '/' + str, success, err)
        },
        timerTask(str, success, err) {
            get(URL.timerTask + '/' + str, success, err)
        },
        addTimerTask(data, success, err) {
            post(URL.addTimerTask, data, success, err)
        },
        updateTimerTask(data, success, err) {
            put(URL.updateTimerTask, data, success, err)
        },
        delTimerTask(data, success, err) {
            post(URL.delTimerTask, data, success, err)
        },
        startUp(data, success, err) {
            let url = URL.startUp;
            post(URL.startUp, data, success, err)
        },
        shutDown(data, success, err) {
            post(URL.shutDown, data, success, err)
        },
        adjustHeatMode(data, success, err) {
            post(URL.adjustHeatMode, data, success, err)
        },
        adjustCoolMode(data, success, err) {
            post(URL.adjustCoolMode, data, success, err)
        },
        adjustHeatTemperature(data, success, err) {
            post(URL.adjustHeatTemperature, data, success, err)
        },
        adjustCoolTemperature(data, success, err) {
            post(URL.adjustCoolTemperature, data, success, err)
        },
        adjustHeatAndDiNuanMode(str, success, err) {
            get(URL.adjustHeatAndDiNuanMode + '?' + str, success, err)
        },

        eqSave(params, success, err) {
            post(URL.eqSave, params, success, err)
        },

        eqBind(params, success, err) {
            post(URL.eqBind, params, success, err)
        },

        equipmentRepairAdd(params, success, err) {
            post(URL.equipmentRepairAdd, params, success, err)
        },

        equipmentRepairAddWx(params, success, err) {
            post(URL.equipmentRepairAddWx, params, success, err)
        },

        eqMatch(param, success, err) {
            post(URL.eqMatch, param, success, err)
        },

        eqText(str, success, err) {
            get(URL.eqText + '?' + str, success, err)
        },

        eqRoomList(str, success, err) {
            get(URL.eqRoomList + '?' + str, success, err)
        },

        eqRoomAdd(params, success, err) {
            post(URL.eqRoomAdd, params, success, err)
        },

        useSceneList(str, success, err) {
            get(URL.useSceneList + '?' + str, success, err)
        },

        useSceneAdd(params, success, err) {
            post(URL.useSceneAdd, params, success, err)
        },

        readWaterTemerature(str, success, err) {
            get(URL.readWaterTemerature + '?' + str, success, err)
        },

        eqUnbind(param, success, err) {
            post(URL.eqUnbind, param, success, err)
        },

        updateMobilePhone(params, success, err) {
            post(URL.updateMobilePhone, params, success, err)
        },

        authUser(success, err) {
            get(URL.authUser, success, err)
        },

        isLogin(success, err) {
            get(URL.authUser, success, err)
        },

        editScene(params, success, err) {
            put(URL.editScene, params, success, err)
        },

        delScene(params, success, err) {
            post(URL.delScene, params, success, err)
        },

        updateBind(params, success, err) {
            post(URL.updateBind, params, success, err)
        },

        delRoom(param, success, err) {
            post(URL.delRoom, param, success, err)
        },

        editRoom(params, success, err) {
            put(URL.editRoom, params, success, err)
        },

        editEqName(params, success, err) {
            put(URL.editEqName, params, success, err)
        },

        articleList(str, success, err) {
            get(URL.articleList + '?' + str, success, err)
        },

        articleGet(id, success, err) {
            get(URL.articleGet + '?id=' + id, success, err)
        },

        /*新风*/
        freshStartUp(param, success, err) {
            let url = URL.freshStartUp;
            post(url, param, success, err)
        },

        freshShutDown(param, success, err) {
            let url = URL.freshShutDown;
            post(url, param, success, err)
        },
        freshAdjustHeatMode(parm, success, err) {
            let url = URL.freshAdjustHeatMode;
            post(url, parm, success, err)
        },
        freshAdjustCoolMode(parm, success, err) {
            let url = URL.freshAdjustCoolMode;
            post(url, parm, success, err)
        },
        freshAdjustVentilationMode(parm, success, err) {
            let url = URL.freshAdjustVentilationMode;
            post(url, parm, success, err)
        },
        freshAdjustHeatTemperature(param, success, err) {
            let url = URL.freshAdjustHeatTemperature;
            post(url, param, success, err)
        },
        freshAdjustCoolTemperature(param, success, err) {
            let url = URL.freshAdjustCoolTemperature;
            post(url, param, success, err)
        },

        freshAdjustHeatHumidity(param, success, err) {
            let url = URL.freshAdjustHeatHumidity;
            post(url, param, success, err)
        },
        freshAdjustCoolHumidity(param, success, err) {
            let url = URL.freshAdjustCoolHumidity;
            post(url, param, success, err)
        },
        startUpFan(data, success, err) {
            post(URL.startUpFan, data, success, err)
        },
        shutDownFan(data, success, err) {
            post(URL.shutDownFan, data, success, err)
        },
        adjustHeatModeFan(data, success, err) {
            post(URL.adjustHeatModeFan, data, success, err)
        },
        dehumidificationMode(data, success, err) {
            post(URL.dehumidificationMode, data, success, err)
        },
        loopMode(data, success, err) {
            post(URL.loopMode, data, success, err)
        },
        adjustCoolModeFan(data, success, err) {
            post(URL.adjustCoolModeFan, data, success, err)
        },
        adjustVentilationMode(data, success, err) {
            post(URL.adjustVentilationMode, data, success, err)
        },
        adjustUnderMode(data, success, err) {
            post(URL.adjustUnderMode, data, success, err)
        },
        adjustUnderHeatMode(data, success, err) {
            post(URL.adjustUnderHeatMode, data, success, err)
        },
        adjustHeatTemperatureFan(data, success, err) {
            post(URL.adjustHeatTemperatureFan, data, success, err)
        },
        homeCoolingHumiditySetting(data, success, err) {
            post(URL.homeCoolingHumiditySetting, data, success, err)
        },
        adjustCoolTemperatureFan(data, success, err) {
            post(URL.adjustCoolTemperatureFan, data, success, err)
        },
        adjustWindSpeedFan(data, success, err) {
            post(URL.adjustWindSpeed, data, success, err)
        },
        windSpeed(data, success, err) {
            post(URL.windSpeed, data, success, err)
        },
        getWxAcc(param, success, err) {
            get(URL.wxAcc + '?url=' + param, success, err)
        },
        sterilizationMode(param, success, err) {
            post(URL.sterilizationMode, param, success, err)
        },
        dehumStartUp(param, success, err) {
            let url = URL.dehumStartUp;
            post(url, param, success, err)
        },
        dehumStartDown(param, success, err) {
            let url = URL.dehumStartDown;
            post(url, param, success, err)
        }
    }
;
export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js